import React from 'react';
import './KeyConversions.css';

function KeyConversions({ data }) {
    const getRateClass = (rate) => {
        if (rate >= 70) return 'conversion-high';
        if (rate >= 40) return 'conversion-medium';
        return 'conversion-low';
    };

    const conversions = [
        {
            label: 'Applicant → Phone Screen',
            value: data?.applicantToPhoneScreen || 0,
            description: 'New candidates to phone screen'
        },
        {
            label: 'Phone Screen → HM Interview',
            value: data?.phoneScreenToHmInterview || 0,
            description: 'Phone screen to first interview'
        },
        {
            label: 'HM Interview → Offer',
            value: data?.hmInterviewToOffer || 0,
            description: 'Interviews to offer extended'
        }
    ];

    return (
        <div className="key-conversions-container">
            <h2 className="key-conversions-title">Key Conversions</h2>
            <div className="key-conversions-grid">
                {conversions.map((conversion, index) => (
                    <div
                        key={index}
                        className={`key-conversion-card ${getRateClass(conversion.value)}`}
                    >
                        <div className="key-conversion-percentage">{conversion.value.toFixed(1)}%</div>
                        <div className="key-conversion-label">{conversion.label}</div>
                        <div className="key-conversion-description">{conversion.description}</div>
                        <div className="key-conversion-bar">
                            <div
                                className="key-conversion-fill"
                                style={{ width: `${Math.min(conversion.value, 100)}%` }}
                            ></div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default KeyConversions;
